<div class="table-row">
  <div class="table-item">{{ question.question }}</div>
  <div class="table-item">{{ correctAnswer.title }}</div>
  <div class="table-item">{{ question.answers.length }}</div>
  <div class="table-item">
    <gl-button
      icon
      icon-center="glicon-edit"
      [routerLink]="['/questions', question.id]"
      class="right"
      title="{{ 'actions.edit' | translate }} {{ question.name }}"
    >
    </gl-button>
    <ng-content select="[row-actions]"></ng-content>
  </div>
</div>
